module.exports = __webpack_public_path__ + "static/img/20211211_3.bac3cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_3.png
// module id = Hfnj
// module chunks = 0